"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var apply_service_utils_1 = __importDefault(require("../../../common/src/constrains/contract_form/apply_service_utils"));
var object_utils_1 = __importDefault(require("../../../common/src/utils/sales_force/object_utils"));
var OpportunityAdditionalTablet = /** @class */ (function (_super) {
    __extends(OpportunityAdditionalTablet, _super);
    function OpportunityAdditionalTablet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            opportunityId: '',
            additionalTabletPrice: '',
            additionalTabletContractState: '',
            additionalTabletRequestStartDate: null,
            additionalTabletContractEdate: null,
            additionalTabletItPeriod: '',
            additionalTabletBunkatuFlg: '',
            additionalTabletItFlg: '',
            additionalTabletTokubetuFlg: '',
            additionalTabletTokubetuDetail: '',
            opportunityAdditionalTabletId: '',
            opportunityAdditionalTabletName: '',
            additionalTabletContractStartDate: null,
            additionalTabletPriceBook2Id: '',
            additionalTabletProductId: '',
            additionalTabletProductInitialFeeId: '',
            opportunityAdditionalTabletItemId: '',
            additionalTabletPriceBook2Name: '',
            additionalTabletPriceBook2Description: '',
            additionalTabletProductName: '',
            additionalTabletPriceDefault: '',
            additionalTabletPriceBookMonth: '',
            additionalTabletPriceBookData: [],
            additionalTabletProductPlanName: '',
            additionalTabletCancelFlag: '',
            // 登録されたSFレコードを格納する。
            additionalTabletRegisterObj: [],
            additionalTablets: ''
        };
        _this.additionalTabletPrice = '';
        _this.additionalTabletItFlgDisabled = false;
        _this.additionalTabletItFlgDescription = false;
        // 表示専用 DBと連携しない
        _this.fixedTextPriceList = 'Rehab Cloud';
        // 表示専用 DBと連携しない
        _this.fixedTextItem = 'Rehab Cloud タブレット + Rehab Cloud タブレット初回手数料';
        return _this;
    }
    OpportunityAdditionalTablet.prototype.data = function () {
        return {
            tabletHeaders: [
                {
                    text: '商品名',
                    value: 'productName'
                },
                {
                    text: '単価',
                    value: 'unitPrice'
                },
                { text: '台数',
                    value: 'tabletNumbers'
                },
                { text: '合計',
                    value: 'total'
                }
            ],
            tabletItems: [
                {
                    productName: '',
                    unitPrice: 0,
                    tabletNumbers: 0,
                    total: 0
                }
            ],
            tableHeadersOpportunity: [
                {
                    text: '商談名',
                    value: 'opportunityName'
                },
                {
                    text: '商談ID',
                    value: 'opportunityId'
                },
                {
                    text: '商談商品ID（Rehab Cloud タブレット）',
                    value: 'opportunityLineItemsId'
                },
                {
                    text: '商談商品ID（Rehab Cloud タブレット初回手数料）',
                    value: 'opportunityLineItemsInitialFeeId'
                }
            ],
            tableItemsOpportunity: [
                {
                    opportunityName: "",
                    opportunityId: "",
                    opportunityLineItemsId: "",
                    opportunityLineItemsInitialFeeId: ""
                }
            ]
        };
    };
    OpportunityAdditionalTablet.prototype.reCorrect = function () {
        this.$emit('re-correct');
    };
    OpportunityAdditionalTablet.prototype.periodChange = function () {
        var sdate = this.form.applyInfoAdditionalTabletStartDate;
        this.salesForceInfo.additionalTabletContractStartDate = sdate;
        this.salesForceInfo.additionalTabletRequestStartDate = object_utils_1.default.getSdateNextContract(this.salesForceInfo.additionalTabletContractStartDate, '1');
    };
    OpportunityAdditionalTablet.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityAdditionalTablet.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityAdditionalTablet.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityAdditionalTablet.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
    };
    OpportunityAdditionalTablet.prototype.salesForceAutoComplete = function () {
        if (value_checker_1.default.isBlank(this.salesForceInfo.additionalTabletContractStartDate)) {
            this.salesForceInfo.additionalTabletContractStartDate = this.form['applyInfoAdditionalTabletStartDate'];
        }
        if (value_checker_1.default.isBlank(this.salesForceInfo.opportunityAdditionalTabletName)) {
            this.salesForceInfo.opportunityAdditionalTabletName = this.form.officeInfoOfficeName + "_" + date_parser_1.default.toString(new Date());
        }
        if (value_checker_1.default.isPresent(this.salesForceInfo.opportunityId) && value_checker_1.default.isBlank(this.salesForceInfo.opportunityAdditionalTabletId)) {
            if (!apply_service_utils_1.default.isUseKobetuOpportunity(this.form)) {
                this.salesForceInfo.opportunityAdditionalTabletId = this.salesForceInfo.opportunityId;
            }
        }
        this.periodChange();
    };
    OpportunityAdditionalTablet.prototype.initDataChange = function () {
        this.form = this.initData;
        this.salesForceAutoComplete();
    };
    OpportunityAdditionalTablet.prototype.makeSalesForceUrl = function () {
        return this.$customEnv.get('SALES_FORCE_BASE_URL') + "lightning/r/Opportunity/";
    };
    OpportunityAdditionalTablet.prototype.getSalesForcePeriod = function () {
        return object_utils_1.default.getSalesForcePeriod(this.form.applyInfoAdditionalTabletPeriod);
    };
    OpportunityAdditionalTablet.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
        this.salesForceAutoComplete();
    };
    OpportunityAdditionalTablet.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                // 利用開始月が未入力の場合、登録することは出来ない。
                if (this.isStartDateBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = "利用開始月が未入力です！！";
                    return [2 /*return*/];
                }
                // タブレット台数が未入力の場合、登録することは出来ない。
                // タブレット台数がundefinedの場合があるので、[void 0]で判定する。
                if (value_checker_1.default.isBlank(String(self_.salesForceInfo.additionalTablets)) ||
                    self_.salesForceInfo.additionalTablets === void 0 ||
                    self_.salesForceInfo.additionalTablets === 0) {
                    this.showAlertDialog = true;
                    this.alertMessage = "タブレット台数が未入力です！！";
                    return [2 /*return*/];
                }
                // 特別対応が未入力の場合、登録することは出来ない。
                if (this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = "特別対応の詳細への入力は必須です！！";
                    return [2 /*return*/];
                }
                // if (self_.salesForceInfo.additionalTabletRegisterObj.length &&
                //     self_.salesForceInfo.additionalTabletRegisterObj.length !== void 0
                // ) 
                if (self_.salesForceInfo.additionalTabletRegisterObj &&
                    self_.salesForceInfo.additionalTabletRegisterObj.length !== 0 &&
                    self_.salesForceInfo.additionalTabletRegisterObj.length !== void 0) {
                    this.confirmMessage = '商談／商談商品（タブレット単体申込み）を<strong>更新</strong>します。よろしいですか？';
                    this.confirmMessage += "\u8FFD\u52A0\u3055\u308C\u308B\u53F0\u6570\u306F\u3001<span style=\"font-weight: bold; background-color: #ffff66;\">" + this.salesForceInfo.additionalTablets + "\u53F0</span>\u3068\u306A\u308A\u307E\u3059\u3002";
                }
                else {
                    this.confirmMessage = '商談／商談商品（タブレット単体申込み）を<strong>新規に追加</strong>します。よろしいですか？';
                    this.confirmMessage += "\u8FFD\u52A0\u3055\u308C\u308B\u53F0\u6570\u306F\u3001<span style=\"font-weight: bold; background-color: #ffff66;\">" + this.salesForceInfo.additionalTablets + "\u53F0</span>\u3068\u306A\u308A\u307E\u3059\u3002";
                }
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityAdditionalTablet.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityAdditionalTablet.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityAdditionalTablet.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.additionalTabletTokubetuDetail);
    };
    OpportunityAdditionalTablet.prototype.isStartDateBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.applyInfoAdditionalTabletStartDate);
    };
    OpportunityAdditionalTablet.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.opportunityAdditionalTabletItemId) {
            this.salesForceInfo.opportunityAdditionalTabletItemId = '';
        }
        if (!this.salesForceInfo.opportunityAdditionalTabletItemId) {
            this.salesForceInfo.opportunityAdditionalTabletItemId = '';
        }
        var reflectType = [ReflectType_1.SalesForceReflectType.OPPORTUNITY_ADDITIONAL_TABLET,
            ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_ADDITIONAL_TABLET,
            ReflectType_1.SalesForceReflectType.OPPORTUNITY_ITEM_ADDITIONAL_TABLET_INITIAL_FEE];
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                additionalTabletPrice: this.salesForceInfo.additionalTabletPrice,
                additionalTabletContractState: this.salesForceInfo.additionalTabletContractState,
                additionalTabletRequestStartDate: this.salesForceInfo.additionalTabletRequestStartDate,
                additionalTabletContractEdate: this.salesForceInfo.additionalTabletContractEdate,
                additionalTabletItPeriod: this.salesForceInfo.additionalTabletItPeriod,
                additionalTabletTokubetuFlg: this.salesForceInfo.additionalTabletTokubetuFlg,
                additionalTabletTokubetuDetail: this.salesForceInfo.additionalTabletTokubetuDetail,
                opportunityAdditionalTabletId: this.salesForceInfo.opportunityAdditionalTabletId.trim(),
                opportunityAdditionalTabletName: this.salesForceInfo.opportunityAdditionalTabletName,
                additionalTabletContractStartDate: this.salesForceInfo.additionalTabletContractStartDate,
                additionalTabletPriceBook2Id: this.salesForceInfo.additionalTabletPriceBook2Id,
                opportunityAdditionalTabletItemId: this.salesForceInfo.opportunityAdditionalTabletItemId.trim(),
                additionalTabletPriceBookMonth: this.salesForceInfo.additionalTabletPriceBookMonth,
                additionalTabletPriceBookData: this.salesForceInfo.additionalTabletPriceBookData,
                // 申込タブレット数
                additionalTablets: this.salesForceInfo.additionalTablets
            },
            reflectType: reflectType,
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_ADDITIONAL_TABLET, ReflectType_1.SalesForceReflectType.TORIHIKISAKI]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityAdditionalTablet.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityAdditionalTablet.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityAdditionalTablet.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityAdditionalTablet.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityAdditionalTablet.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityAdditionalTablet.prototype, "initSalesForceDataChange", null);
    OpportunityAdditionalTablet = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityAdditionalTablet);
    return OpportunityAdditionalTablet;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityAdditionalTablet;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityAdditionalTablet.vue
// module id = E8K7
// module chunks = 1